import { sortBy } from 'lodash';
import type { PartnerMailingAddress, TeamSearchFields } from '../../types';

type MailingAddressWithCoords = Omit<
  PartnerMailingAddress,
  'geolocationLatitude' | 'geolocationLongitude'
> & {
  geolocationLatitude: string;
  geolocationLongitude: string;
};

export type TeamWithMailingAddress = Omit<
  TeamSearchFields,
  'mailingAddress'
> & {
  mailingAddress: MailingAddressWithCoords;
};

export function sortTeamsByGroupKey(teams: TeamWithMailingAddress[]) {
  return sortBy(teams, (team) => [
    `${team.mailingAddress.geolocationLatitude}_${team.mailingAddress.geolocationLongitude}`,
    [team.legalName, team.alias].filter((v) => !!v).join(' - '),
  ]);
}
